<template>
  <div class="related-row">
    <div class="table-container">
      <div style="margin-top: 10px" v-if="showTitle">{{ transportTypeTitle }}指令执行明细</div>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="CommonTransportation"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :toolbar="{}"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        :valid-config="{ autoPos: true, message: 'inline' }"
        height="300"
      >
        <!-- <template v-slot:buttons>
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template> -->
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in _tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'settlementBusinessType'">{{
              businessCategory?.find((item) => item.value == row['settlementBusinessType'])?.label
            }}</template>
            <template v-else-if="item.field === 'settlementStatus'">{{
              settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'paymentStatus'">{{
              pay_paymentStatus?.find((item) => item.value == row['paymentStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'printFlag'">{{
              row.printFlag == 1 ? '已打印' : '未打印'
            }}</template>
            <!-- <template v-else-if="item.field === 'businessCategory'">{{
              getSettlementBusinessTypeStatus(row.businessCategory)
            }}</template> -->
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { defaultTableColumn } from './index.js';
  export default {
    name: 'CommonTransportation',
    props: {
      preSettlements: {
        type: Array,
        default: () => [],
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
      transportType: {
        type: String,
        default: '',
      },
      marked: {
        type: String,
        default: '普通运输',
      },
    },
    data() {
      return {
        tableData: [],

        columnList: defaultTableColumn,
        selectionList: [],
      };
    },
    watch: {
      preSettlements: {
        handler(val) {
          this.fullFetchTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    computed: {
      // searchFormColumns() {
      //   return searchColumns(this);
      // },
      transportTypeTitle() {
        return this.transportType;
      },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      pay_paymentStatus() {
        return this.dictListMap?.pay_paymentStatus;
      },
      _tableColumnList() {
        if (this.marked == '集卡运输') {
          let tableColumnListCopy = JSON.parse(JSON.stringify(defaultTableColumn));
          tableColumnListCopy.splice(3, 0, {
            field: 'actualTransportContainerNo',
            title: '实际运输箱号',
            width: '150',
          });
          return tableColumnListCopy;
        } else {
          return defaultTableColumn;
        }
        // return tableColumnList;
      },
    },
    methods: {
      //插入表格数据
      fullFetchTableData(val) {
        this.$nextTick(() => {
          const $table = this.$refs.CommonTransportation;
          $table.remove(this.getTableData()); //先删除表格所有数据
          $table?.insertAt(val, 0); // 再插入最新的数据
        });
      },

      getTableData() {
        const $table = this.$refs.CommonTransportation;
        return $table.getTableData().fullData;
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(this.selectionList);
        const IdList = this.selectionList.map((item) => item.id);
        this.tableData = this.getTableData().filter((item) => !IdList.includes(item.id));
        this.$emit('deleteTableHandler', IdList, this.selectionList);
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .related-row {
    background: #fff;
    .table-container {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
  ::v-deep {
    .vxe-toolbar.size--mini {
      height: 5px;
    }
  }
</style>
